import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnehealthLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 61.939,
	height: 12.822,
	viewBox: "0 0 61.939 12.822",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".logoOneHealth{fill:#464B52 !important;opacity: 1;}" }) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1041.13,504.869v-8.452l-2.189,1.748a1.236,1.236,0,0,1-1.154-1.188c0-.6.356-.912,1-1.409a15.8,15.8,0,0,1,2.673-1.9,2.555,2.555,0,0,1,2.062.169v11.032Z",
				transform: "translate(-1037.787 -492.361)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1093.721,491.592c.4-.8,2.3-1.5,4.031-.9,2.693.932,2,3.8,2.062,8.723h-2.376v-5.006q0-1.969-1.816-1.969a1.63,1.63,0,0,0-1.417.678c-.778,1.093-.371,2.213-.484,6.3h-2.376c.11-11.806-.255-11.9.339-12.287a2.558,2.558,0,0,1,2.036-.017Z",
				transform: "translate(-1081.87 -486.908)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1159.331,510.326c0,1.688-1.033,2.291-2.715,2.291h-3.394a2.375,2.375,0,0,0,2.563,1.663,6.647,6.647,0,0,0,1.672-.161,5.509,5.509,0,0,0,.721-.229l.645,1.68a4.229,4.229,0,0,1-.976.347c-7.32,1.877-8.442-4.927-5.8-7.636C1154.3,505.961,1159.331,506.738,1159.331,510.326Zm-2.24-.2c0-1.827-3.05-2.246-3.8.1a2.67,2.67,0,0,0-.136.814C1156.209,510.888,1157.091,511.5,1157.091,510.122Z",
				transform: "translate(-1130.783 -503.418)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1215.312,516.191a11.637,11.637,0,0,1-1.23.17c-3.165.3-7.034.53-7.034-2.63a2.436,2.436,0,0,1,2.2-2.682,13.324,13.324,0,0,1,3.742-.068,1.709,1.709,0,0,0-.543-1.493,3.728,3.728,0,0,0-3.725.144q-.2.127-.314.2c-.8-.458-1.432-2.461,2.24-2.461C1216.411,507.366,1215.215,510.748,1215.312,516.191Zm-2.342-3.734c-.15-.05-2.475-.34-3.216.28a1.378,1.378,0,0,0-.3,1.4c.306,1,2.52.87,3.513.645Z",
				transform: "translate(-1177.136 -503.751)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1268.462,487.129a2.557,2.557,0,0,1,2.036-.017v12.3h-2.376C1268.232,487.609,1267.867,487.516,1268.462,487.129Z",
				transform: "translate(-1227.409 -486.908)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1294.242,498.944v3.75c0,.765.274,1.273,1.256,1.273a2.421,2.421,0,0,0,1.307-.441l.882,1.426c-1.154,1.139-4.008,1.352-5.091.118-1.144-1.3-.587-2.837-.73-6.126h-.56c-1.146,0-1.229-.87-.8-1.935h1.358c.062-1.181-.184-1.952.339-2.291a2.561,2.561,0,0,1,2.036-.017v2.308c1.5.052,2.264-.143,2.622.255a1.444,1.444,0,0,1,.127,1.332q-.1.263-.136.348Z",
				transform: "translate(-1245.651 -493.156)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "logoOneHealth",
				d: "M1342.484,491.592c.4-.8,2.3-1.5,4.031-.9,2.693.932,2,3.8,2.062,8.723H1346.2v-5.006q0-1.969-1.816-1.969a1.63,1.63,0,0,0-1.417.678c-.779,1.093-.371,2.213-.484,6.3h-2.376c.11-11.806-.256-11.9.339-12.287a2.558,2.558,0,0,1,2.036-.017Z",
				transform: "translate(-1286.673 -486.908)"
			})
		]
	})]
});
export default SvgOnehealthLogo;
